import '../css/mainLayout.css';
import React from 'react';
import FullApp from '../fullapp';
import Landing from '../components/landing/main.js'

const IndexPage = () => (
  <FullApp>
      <Landing/>
  </FullApp>
);

export default IndexPage;
